import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useState } from "react";
import { baseVideoUrl } from "../../api";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ViewVideoModal = ({ open, onClose, onAccept, video }) => {
  
  const { t } = useTranslation("common");

  const [checked, setChecked] = useState(false);
  const { vehicle_id } = useSelector((state) => state.myGarage);

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleAccept = () => {
    if (checked) {
      onAccept();
      onClose();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      scroll="paper"
      sx={{
        color: "text.secondary",
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5">{t("Vehicle Video")}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 2,
          }}
        >
          <video
            controls
            autoPlay
            style={{ maxWidth: "100%", maxHeight: "500px" }}
          >
            <source
              src={baseVideoUrl + vehicle_id + "/" + video}
              type="video/mp4"
            />
            {t("Your browser does not support the video tag.")}
          </video>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ViewVideoModal;